'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECT_KEY = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.initRequestParams = initRequestParams;
exports.getFormComponents = getFormComponents;
exports.generateColumns = generateColumns;
exports.fillColumnsWidth = fillColumnsWidth;

var _lodash = require('lodash');

var _formatter = require('../common/formatter');

var SELECT_KEY = exports.SELECT_KEY = 'jsxselected';

/** 从url中获取参数 */
function initRequestParams(fieldId, global) {
  var params = global && global.params || {};

  return _extends({}, params, {
    matterType: params.matterType || window.matterType,
    matterId: params.matterId,
    endpoint: params.endpoint,
    sequenceNo: params.sequenceNo || window.sequenceNo,
    tablePropertyId: fieldId
  });
}

function getFormComponents(coms) {
  var _this = this;

  if (!coms) {
    return null;
  }
  var result = [];
  coms.forEach(function (com) {
    var hasComponentSchema = !!com.props.componentSchema;
    var comInfo = hasComponentSchema ? com.props.componentSchema : com;
    var childrenFormComs = _this.getFormComponents(comInfo.children);
    if (childrenFormComs && childrenFormComs.length > 0) {
      result = result.concat(childrenFormComs);
    }
  });
  return result;
}

function generateColumns(props) {
  var showSortable = props.showSortable,
      initialSchema = props.initialSchema,
      children = props.children;

  var childSchemas = initialSchema.children || getFormComponents(children);
  var columns = [];
  if (!(0, _lodash.isEmpty)(childSchemas)) {
    columns = childSchemas.filter(function (item) {
      var itemProps = item && item.props || {};
      // 展示的时候过滤掉隐藏列
      return itemProps.visible;
    }).map(function (item) {
      var itemProps = item && item.props || {};
      itemProps.showReadonlyValue = true;
      return {
        dataIndex: itemProps.fieldId,
        title: itemProps.label,
        // sortable: !!showSortable,
        cell: function cell(value) {
          // 转换逻辑需要保持一致，需要单独写
          return (0, _formatter.defaultValueFormatter)(value, item.componentName, itemProps, (0, _lodash.get)(itemProps || {}, 'dataSource.options', []));
        }
      };
    });
  }

  return columns;
}

function fillColumnsWidth(columns) {
  if ((0, _lodash.isEmpty)(columns)) {
    return [];
  }
  var count = columns.filter(function (item) {
    return !item.hidden && item.dataIndex !== SELECT_KEY;
  }).length;
  var hasAction = columns.some(function (item) {
    return item.dataIndex === 'action';
  }) && columns.length > 1;
  if (count > 4) {
    columns.forEach(function (item) {
      if (item.width) return true;
      item.width = (item.title && item.title.length + 5 || 10) + 'rem';
    });
  } else {
    var width = hasAction ? 85 / (count - 1) + '%' : 100 / count + '%';
    columns.forEach(function (item) {
      if (hasAction && item.dataIndex === 'action') {
        item.width = '15%';
      } else {
        item.width = width;
      }
    });
  }
  return columns;
}